import React from 'react';
import { Customer } from '../../types';
import { ValidationUtils } from '../../utils/validation';

interface CompanyGoalProps {
  customer: Customer;
}

const CompanyGoal: React.FC<CompanyGoalProps> = ({ customer }) => {
  const { companyGoal, companyName } = customer;

  // Don't render if no goal is provided
  if (!companyGoal || companyGoal.trim() === '') {
    return null;
  }

  const truncateGoal = (goal: string, maxLength: number = 500): string => {
    if (goal.length <= maxLength) return goal;
    return goal.substring(0, maxLength - 3) + '...';
  };

  const getSafeHtml = (htmlContent: string): string => {
    const truncatedContent = truncateGoal(htmlContent);
    return ValidationUtils.sanitizeRichText(truncatedContent);
  };


  return (
    <div className="company-goal">
      <div className="company-goal-content">
        <div className="goal-header">
          <div className="goal-icon">🎯</div>
          <div className="goal-label">
            <span className="goal-title">Your Goal</span>
            <span className="goal-subtitle">What {companyName} aims to achieve</span>
          </div>
        </div>
        <div className="goal-description">
          <div 
            className="goal-text" 
            dangerouslySetInnerHTML={{ __html: getSafeHtml(companyGoal) }}
          />
        </div>
        {companyGoal.length > 250 && (
          <div className="goal-meta">
            <span className="goal-length">{companyGoal.length} characters</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyGoal;